import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mainContainer" }
const _hoisted_2 = ["onmouseup", "onmouseleave", "onmousemove", "onmousedown"]
const _hoisted_3 = ["onmousedown"]
const _hoisted_4 = {
  key: 0,
  class: "scoreTooltip"
}
const _hoisted_5 = ["onmousedown"]
const _hoisted_6 = {
  key: 0,
  class: "scoreTooltip"
}
const _hoisted_7 = { class: "labels" }
const _hoisted_8 = {
  key: 0,
  class: "label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cross_icon = _resolveComponent("cross-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "sliderContainer",
      ref: "container",
      onmouseup: _ctx.moveSlider,
      onmouseleave: _ctx.stopSliding,
      onmousemove: _ctx.slide,
      onmousedown: _ctx.startSliding
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "backFill" }, null, -1)),
      (_ctx.active && _ctx.range)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "thumb",
            onmousedown: _ctx.startSlidingLeft
          }, [
            (_ctx.isSliding)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.minValue + 1), 1))
              : _createCommentVNode("", true)
          ], 8, _hoisted_3))
        : _createCommentVNode("", true),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "fill" }, null, -1)),
      _createElementVNode("div", {
        class: "thumb",
        onmousedown: _ctx.startSlidingRight
      }, [
        (_ctx.isSliding)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.maxValue), 1))
          : _createCommentVNode("", true)
      ], 8, _hoisted_5)
    ], 8, _hoisted_2),
    _createElementVNode("div", _hoisted_7, [
      (!_ctx.hideLabel)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      (_ctx.active && !_ctx.hideDiscardButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "discard",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.discard && _ctx.discard(...args))),
            title: "Discard Metric"
          }, [
            _createVNode(_component_cross_icon, {
              style: {"margin-top":"-1px"},
              height: 18,
              width: 18,
              iconColor: "var(--darkgrey)"
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}